import { getLang } from "helpers/themeHelpers";

export const linkToTopSoldCars = () => {
  const locale = getLang();
  return `/${locale}/top-sold-cars`;
};
